export const host = process.env.REACT_APP_HOST
export const host_without_last_slash = host?.endsWith('/') ? host.slice(0, -1) : host;
